import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import * as DelayActionSubTypes from 'automation-ui-action-features/actions/delay/constants/DelayActionSubTypes';
import Trackables from 'automation-ui-usage-tracking/Trackables';
export const ADD_DELAY = 'addDelayBeforeBranch';
export const TooltipTypes = {
  ADD_DELAY
};
export const TooltipConfig = {
  [TooltipTypes.ADD_DELAY]: {
    shouldShow: ({
      fromActionType,
      toActionType
    }) => {
      const branchActionTypes = [ActionTypes.LIST_BRANCH, ActionTypes.AB_TEST_BRANCH, ActionTypes.STATIC_BRANCH];
      return fromActionType && fromActionType === ActionTypes.EMAIL && toActionType && branchActionTypes.includes(toActionType);
    },
    onClickAdd: ({
      trackEvent,
      routeToAction
    }) => {
      routeToAction({
        configId: ActionTypes.DELAY,
        extraParams: {
          type: DelayActionSubTypes.DURATION,
          addedByTooltip: TooltipTypes.ADD_DELAY
        }
      });
      trackEvent(Trackables.DELAY_TOOLTIP_ACCEPTED);
    },
    onDismiss: ({
      trackEvent
    }) => {
      trackEvent(Trackables.DELAY_TOOLTIP_DISMISSED);
    }
  }
};